import { Fitter } from '@sc/data-access-models';

export interface FitterCommentsInputData {
  fitter: Fitter;
  itineraryDistanceInMeters: number;
  itineraryDurationInSeconds: number;
}
